import { render, staticRenderFns } from "./ApplyFinancialClaim.vue?vue&type=template&id=18624866&scoped=true&"
import script from "./ApplyFinancialClaim.vue?vue&type=script&lang=js&"
export * from "./ApplyFinancialClaim.vue?vue&type=script&lang=js&"
import style0 from "./ApplyFinancialClaim.vue?vue&type=style&index=0&id=18624866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18624866",
  null
  
)

export default component.exports